// import { configureStore } from "@reduxjs/toolkit";
// import rootReducer from "../reducers/rootReducer";
// import { loadState,saveState } from "./localStorage";

// const store = configureStore({ reducer: rootReducer, preloadedState: loadState()
// });

// store.subscribe(() => {
//   saveState(store.getState());
// });

// export default store;

// CHANGES MADE BY KHALID STARTS 15/10/24

// store.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducers/rootReducer";
import { loadState, saveState } from "./localStorage";

const store = configureStore({
  reducer: rootReducer,
  preloadedState: loadState(),
});

store.subscribe(() => {
  saveState(store.getState()); // This will save the token along with other state
});

export default store;

// CHANGES MADE BY KHALID ENDS 15/10/24
